import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import DeleteUpcomingModal from "./DeleteUpcomingModal";
import { useDispatch } from "react-redux";
import {
  editLiveStream,
  getCategoryDropDown,
  getLiveStream,
} from "../../../features/slices/liveStream";
import { useSelector } from "react-redux";
import TableSkeleton from "../../TableSkeleton";
import moment from "moment";
import CommonPagination from "../../CommonPagination";
import ExportToExcel from "../../ExportToExcel";
import { toastService } from "../../../utils/toastify";
import filterImg from "../../../assets/images/filter.png";
import { canPerformAction } from "../../../utils/denyAccess";
const initailState = {
  deleteModal: false,
  searchQuery: "",
  id: "",
  category: "",
};
const Upcoming = () => {
  const [iState, setUpdateState] = useState(initailState);
  const [page, setPage] = useState(1);
  const upComingRef = useRef();
  const { deleteModal, searchQuery, id, category } = iState;
  const dispatch = useDispatch();
  const { liveStreamData, loading, categoryDropDownData } = useSelector(
    (state) => {
      return state?.liveStream;
    }
  );

  const handleDeleteModal = (id) => {
    setUpdateState({ ...iState, deleteModal: true, id: id });
  };

  useEffect(() => {
    dispatch(getCategoryDropDown());
    dispatch(getLiveStream({ page, streamType: "Upcoming" }));
  }, [page]);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getLiveStream({ search: searchQuery?.trim(), streamType: "Upcoming" })
        ).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const hanldeClose = () => {
    setUpdateState({ ...iState, deleteModal: false });
  };
  const handleDelete = useCallback(async () => {
    try {
      const res = await dispatch(editLiveStream({ id: id, status: "DELETED" }));

      if (res?.payload?.code === 200) {
        toastService.success("upcoming liveStream deleted successfully");
        dispatch(getLiveStream({ page, streamType: "Upcoming" }));
        hanldeClose();
      } else {
        toastService.error(res?.payload?.message);
      }
    } catch (error) {
      toastService.error(
        "An error occurred while deleting the upcoming liveStream"
      );
    }
  }, [id, page]);

  const handleFilter = () => {};
  const handleChangeCategory = (e) => {
    console.log("event", e.target.value);
    setUpdateState((prev) => ({
      ...prev,
      category: e.target.value,
    }));
    dispatch(
      getLiveStream({ categoryId: e.target.value, streamType: "Upcoming" })
    );
  };
  const handleReset = () => {
    setUpdateState(initailState);
    dispatch(getLiveStream({ page, streamType: "Upcoming" }));
  };
  const handleClickLink = (data) => {
    console.log({ data });
    window.open(data, "_blank");
  };
  return (
    <>
      <div className="tab-pane fade show active" id="Upcoming">
        <div className="NewFilter">
          <div className="SearchBox">
            <input
              type="search"
              className="SearchInput"
              placeholder="Search here by ID, Name, or Others"
              name="searchQuery"
              value={searchQuery}
              onChange={(e) => handleSearch(e)}
            />
            <span>
              <i className="fa fa-search" />
            </span>
          </div>

          {/* <button className="FilterBtn">
            <span>
              <img src={filterImg} />
            </span>
            Filters
            <select
              className="form-control"
              name="categoryId"
              // onChange={handleChangeCategory}
            >
              <option>select</option>
              {categoryDropDownData?.result?.map((res) => {
                return <option value={res?._id} key={res?._id}
                >{res?.categoryName}</option>;
              })}
            </select>
          </button> */}

          <div className="Actions">
            <div
              className="form-group"
              style={{
                textAlign: "center",
              }}
            >
              {/* <label
                style={{
                  fontWeight: "bolder",
                  fontWeight: "bolder",
                  display: " block",
                  whiteSpace: "nowrap",
                  margin: "4px 20px",
                }}
              >
                Filter by Category
              </label> */}
              <select
                className="form-control FilterStatus"
                name="categoryId"
                onChange={handleChangeCategory}
              >
                <option value="" hidden>
                  Filter by Category
                </option>
                {categoryDropDownData?.result?.map((res) => {
                  return (
                    <option
                      value={res?._id}
                      selected={res?._id == category}
                      key={res?._id}
                    >
                      {res?.categoryName}
                    </option>
                  );
                })}
              </select>
            </div>
            <button className="Button Cancel" onClick={handleReset}>
              <i className="fa fa-refresh" />
            </button>
            <ExportToExcel
              ref={upComingRef}
              fileName="liveStreamUpcomingData"
            />
          </div>
        </div>
        <div className="TableList">
          <table className="table-hover" ref={upComingRef}>
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Livestream Id</th>
                <th>Livestream Title</th>
                <th>Category &amp; Topics</th>
                <th>Host Name</th>
                <th>Date &amp; Time</th>
                <th>Link</th>
                {canPerformAction("Livestream") && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <TableSkeleton />
              ) : liveStreamData?.result?.[0]?.paginationData?.length > 0 ? (
                liveStreamData?.result?.[0]?.paginationData?.map((res, i) => {
                  return (
                    <tr key={res?._id}>
                      <td>{i + 1}</td>
                      <td>{res?.stream_number}</td>
                      <td>
                        {" "}
                        <div className="fw500">{res?.title}</div>
                      </td>
                      <td>
                        {res?.categoryData?.[0]?.categoryName} &amp;{" "}
                        {res?.topicData?.[0]?.topicName}
                      </td>
                      <td>{res?.teacherName}</td>
                      <td>
                        {res?.date},{moment(res.time, "HH:mm").format("h:mm A")}
                      </td>
                      <td>
                        <a
                          className="BlueLink ml-0"
                          title={res?.link}
                          style={{
                            cursor: "auto",
                          }}
                        >
                          <i
                            className="fa-solid fa-link"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => handleClickLink(res?.link)}
                          />
                          {res?.link}
                        </a>
                      </td>
                      {canPerformAction("Livestream") && (
                        <td>
                          <div className="Actions">
                            <Link
                              to={"/livestream/editUpcomingLiveStream"}
                              className="Edit"
                              state={res}
                            >
                              <i className="fa-regular fa-pen-to-square" />
                            </Link>
                            <a
                              className="Delete"
                              onClick={() => handleDeleteModal(res?._id)}
                            >
                              <i className="fa-regular fa-trash-can" />
                            </a>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={10}>No Upcoming LiveStream Data</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="Pagination">
          {liveStreamData?.result?.[0]?.totalCount?.[0]?.count > 0 && (
            <>
              <p>
                Showing {(page - 1) * 10 + 1} to{" "}
                {Math.min(
                  liveStreamData?.result?.[0]?.paginationData?.length +
                    (page - 1) * 10,
                  liveStreamData?.result?.[0]?.totalCount?.[0]?.count
                )}{" "}
                of {liveStreamData?.result?.[0]?.totalCount?.[0]?.count} results
              </p>
              <div className="PaginationRight">
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    liveStreamData?.result?.[0]?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              </div>
            </>
          )}
        </div>
      </div>
      {deleteModal && (
        <DeleteUpcomingModal
          hanldeClose={hanldeClose}
          handleDelete={handleDelete}
        />
      )}
    </>
  );
};

export default Upcoming;
